import styled from '@emotion/styled';

const Second:React.FC<any> = () => {
  return (
    <Container>
      <Title>한 번에 이해하는 인화구독</Title>
      <CardSection>
        <Card>
          <ImageWrapper>
            <ImgBox src="/images/newLanding/home/alarmD1.png"/>
          </ImageWrapper>
          <TextBoxInCard>
            <BoldText>D-1 알림</BoldText>
            <SmallText>때 되면 톡을 드려요 <br/> 맘편히 맡기세요</SmallText>
          </TextBoxInCard>
        </Card>
        <Card>
          <ImageWrapper>
            <ImgBox src="/images/newLanding/home/selectedPhoto.png"/>
          </ImageWrapper>
          <TextBoxInCard>
            <BoldText>사진 선택</BoldText>
            <SmallText>사랑스런 순간을 <br/> 미리 골라두세요</SmallText>
          </TextBoxInCard>
        </Card>
        <Card>
        <ImageWrapper>
            <ImgBox src="/images/newLanding/home/printlogo.png"/>
          </ImageWrapper>
          <TextBoxInCard>
            <BoldText>25일 인화</BoldText>
            <SmallText>매달 앨범을 <br/> 차곡차곡 채워요</SmallText>
          </TextBoxInCard>
        </Card>
      </CardSection>
    </Container>
  )
}

export default Second;

const Container = styled.div`
  width: 100%;
  height: 380px;
  display: flex;
  flex-direction: column;
  background-color: #e7ded0;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin: 55px auto 40px;
  letter-spacing: -0.9px;
`;

const CardSection = styled.div`
  width: 90%;
  height: 47%;
  margin: 0 auto 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Card = styled.div`
  height: 100%;
  width: 28%;
  /* background-color: aqua; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ImageWrapper = styled.div`
  width: 100%;
  border-radius: 50%;
  background-color: white;
`;
const ImgBox = styled.img`
  width: 100%;
`
const TextBoxInCard = styled.div`
  display: flex;
  width: 100%;
  height: 60px;
  /* background-color: yellow; */
  flex-direction: column;
  justify-content: space-between;
`;

const BoldText = styled.div`
  display: flex;
  margin: 0 auto -2px;
  font-size: 16px;
  font-weight: 600;
`;

const SmallText =styled.div`
  display: flex;
  margin: 0px auto 0px;
  text-align: center;
  font-size: 12px;
`;


